import { HomePage } from "pages/Home/Home";
import { Navigate } from "react-router";

import {
  DASHBOARD,
  ETATPARC,
  MAINTENANCE,
  PLAN,
  TASKS,
} from "constants/api/routeGlobals";
import { Dashboard } from "pages/DashBoard/Dashboard";
import { EtatParc } from "pages/EtatParc/EtatParc";
import { Maintenance } from "pages/Maintenance/Maintenance";
import { PlanPage } from "pages/Plan/PlanPage";
import { Tasks } from "pages/Tasks/Tasks";
import { Route, Routes } from "react-router";

export const routes = (
  <Routes>
    <Route element={<HomePage />}>
      <Route index element={<Navigate to={PLAN} replace />} />
      <Route path={PLAN} element={<PlanPage />} />
      <Route path={DASHBOARD} element={<Dashboard />} />
      <Route path={ETATPARC} element={<EtatParc />} />
      <Route path={MAINTENANCE} element={<Maintenance />} />
      <Route path={TASKS} element={<Tasks />} />
    </Route>
  </Routes>
);
